import BaseCRUDReducer from './CRUDReducer';
import { stripeActions } from '../actions/shop/stripe';

const CRUDReducer = new BaseCRUDReducer(stripeActions);

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/shop_stripe.js